
export class WpReferral {
    constructor(
        public id?: number,
        public ieReferralDt?: any,
        public referralStatusCd?: string,
        public ieCaseNum?: number,
        public ieEdgNum?: number,
        public ieProgramCd?: string,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/wp-referral.model.ts